import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/menu.png'
import _imports_1 from '../assets/logo.png'


const _hoisted_1 = { class: "landing" }
const _hoisted_2 = { class: "landing__content" }
const _hoisted_3 = { class: "landing__topbar" }
const _hoisted_4 = ["title", "aria-label", "aria-pressed"]
const _hoisted_5 = { class: "landing__profile" }
const _hoisted_6 = { class: "landing__profile-name" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "landing__profile-placeholder"
}
const _hoisted_9 = { class: "landing__hero" }
const _hoisted_10 = { class: "landing__insight-cards" }
const _hoisted_11 = { class: "landing__insight-card" }
const _hoisted_12 = { class: "landing__insight-value" }
const _hoisted_13 = { class: "landing__insight-card" }
const _hoisted_14 = { class: "landing__insight-value" }
const _hoisted_15 = {
  key: 0,
  class: "landing__state"
}
const _hoisted_16 = {
  key: 1,
  class: "landing__state landing__state--error"
}
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "landing__menu" }
const _hoisted_19 = { class: "landing-card__head" }
const _hoisted_20 = { class: "landing-card__weekday" }
const _hoisted_21 = { class: "landing-card__date" }
const _hoisted_22 = { class: "landing-card__title" }
const _hoisted_23 = {
  key: 0,
  class: "landing-card__details"
}
const _hoisted_24 = {
  key: 1,
  class: "landing-card__countdown"
}
const _hoisted_25 = { class: "landing-card__footer" }
const _hoisted_26 = { class: "landing-card__price" }
const _hoisted_27 = { class: "landing-card__actions" }
const _hoisted_28 = { class: "landing-card__choice" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["disabled", "onClick"]
const _hoisted_31 = { class: "landing-card__quantity" }
const _hoisted_32 = { class: "landing-card__quantity-controls" }
const _hoisted_33 = ["disabled", "onClick"]
const _hoisted_34 = { class: "landing-card__quantity-value" }
const _hoisted_35 = ["disabled", "onClick"]
const _hoisted_36 = ["disabled", "onClick"]
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 2 }
const _hoisted_40 = { key: 3 }
const _hoisted_41 = ["disabled", "onClick"]
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = {
  key: 2,
  class: "landing-card__status"
}
const _hoisted_45 = {
  key: 0,
  class: "landing-card landing-card--weekly landing__weekly"
}
const _hoisted_46 = { class: "landing-card__head" }
const _hoisted_47 = { class: "landing-card__weekday" }
const _hoisted_48 = { class: "landing-card__date" }
const _hoisted_49 = { class: "landing-card__title" }
const _hoisted_50 = {
  key: 0,
  class: "landing-card__details"
}
const _hoisted_51 = { class: "landing-card__footer landing-card__footer--weekly" }
const _hoisted_52 = { class: "landing-card__price" }
const _hoisted_53 = {
  key: 1,
  class: "landing__history"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NetworkBackground = _resolveComponent("NetworkBackground")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_OrderHistory = _resolveComponent("OrderHistory")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NetworkBackground, { class: "landing__background" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "landing__burger",
          title: 
            _ctx.showHistory ? 'Speiseplan anzeigen' : 'Bestellhistorie anzeigen'
          ,
          "aria-label": 
            _ctx.showHistory ? 'Speiseplan anzeigen' : 'Bestellhistorie anzeigen'
          ,
          "aria-pressed": _ctx.showHistory ? 'true' : 'false',
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleHistory && _ctx.toggleHistory(...args)))
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Bestellhistorie anzeigen"
          }, null, -1)
        ]))], 8, _hoisted_4),
        _createVNode(_component_router_link, {
          class: "landing__info-link",
          to: "/info",
          "aria-label": "Informationen anzeigen",
          title: "Informationen anzeigen"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("svg", {
              class: "landing__info-icon",
              viewBox: "0 0 24 24",
              role: "presentation",
              "aria-hidden": "true"
            }, [
              _createElementVNode("circle", {
                cx: "12",
                cy: "12",
                r: "9",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2"
              }),
              _createElementVNode("path", {
                d: "M12 11v6",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round"
              }),
              _createElementVNode("circle", {
                cx: "12",
                cy: "7",
                r: "1.2",
                fill: "currentColor"
              })
            ], -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.profile?.given_name || _ctx.profile?.name || "Mealorder"), 1),
          (_ctx.userImage)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.userImage,
                alt: "Profilbild",
                class: "landing__profile-image"
              }, null, 8, _hoisted_7))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.profileInitials), 1))
        ])
      ]),
      _createElementVNode("header", _hoisted_9, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "landing__brand" }, [
          _createElementVNode("img", {
            src: _imports_1,
            alt: "ambiFOX",
            class: "landing__logo"
          })
        ], -1)),
        _createElementVNode("ul", _hoisted_10, [
          _createElementVNode("li", _hoisted_11, [
            _cache[3] || (_cache[3] = _createElementVNode("span", {
              class: "landing__insight-icon",
              "aria-hidden": "true"
            }, [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                role: "presentation"
              }, [
                _createElementVNode("rect", {
                  x: "3",
                  y: "5",
                  width: "18",
                  height: "16",
                  rx: "3",
                  ry: "3",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.6"
                }),
                _createElementVNode("path", {
                  d: "M8 3v4M16 3v4M3 11h18",
                  stroke: "currentColor",
                  "stroke-width": "1.6",
                  "stroke-linecap": "round"
                })
              ])
            ], -1)),
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "landing__insight-label" }, "Woche", -1)),
            _createElementVNode("strong", _hoisted_12, _toDisplayString(_ctx.menuMeta.inferred_week || "Noch nicht bekannt"), 1)
          ]),
          _createElementVNode("li", _hoisted_13, [
            _cache[5] || (_cache[5] = _createElementVNode("span", {
              class: "landing__insight-icon",
              "aria-hidden": "true"
            }, [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                role: "presentation"
              }, [
                _createElementVNode("circle", {
                  cx: "12",
                  cy: "12",
                  r: "8",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.6"
                }),
                _createElementVNode("path", {
                  d: "M12 8v4l2.5 2.5",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.6",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ])
            ], -1)),
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "landing__insight-label" }, "Bestellfenster", -1)),
            _createElementVNode("strong", _hoisted_14, _toDisplayString(_ctx.formatAllowedWeekdayList() || "nach Freigabe"), 1)
          ])
        ])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("section", _hoisted_15, " Speiseplan wird geladen … "))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("section", _hoisted_16, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("section", _hoisted_17, [
              (!_ctx.showHistory)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dailyMenuItems, (entry) => {
                        return (_openBlock(), _createElementBlock("article", {
                          class: "landing-card",
                          key: _ctx.entryKey(entry)
                        }, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("small", _hoisted_20, [
                              _cache[8] || (_cache[8] = _createElementVNode("span", {
                                class: "landing-card__weekday-icon",
                                "aria-hidden": "true"
                              }, [
                                _createElementVNode("svg", {
                                  viewBox: "0 0 20 20",
                                  role: "presentation"
                                }, [
                                  _createElementVNode("circle", {
                                    cx: "10",
                                    cy: "10",
                                    r: "8",
                                    stroke: "currentColor",
                                    "stroke-width": "1.5",
                                    fill: "none"
                                  }),
                                  _createElementVNode("circle", {
                                    cx: "10",
                                    cy: "10",
                                    r: "2",
                                    fill: "currentColor"
                                  })
                                ])
                              ], -1)),
                              _createTextVNode(" " + _toDisplayString(entry.day), 1)
                            ]),
                            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.formatDate(entry)), 1)
                          ]),
                          _createElementVNode("h2", _hoisted_22, _toDisplayString(entry.title || "Noch keine Angaben"), 1),
                          (entry.details && entry.details.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.details, (line, detailIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: detailIndex,
                                    class: "landing-card__detail"
                                  }, _toDisplayString(line), 1))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.orderCountdown(entry))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_24, " Bestellschluss in " + _toDisplayString(_ctx.orderCountdown(entry)), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("span", _hoisted_26, [
                              _cache[9] || (_cache[9] = _createElementVNode("span", {
                                class: "landing-card__price-icon",
                                "aria-hidden": "true"
                              }, [
                                _createElementVNode("svg", {
                                  viewBox: "0 0 24 24",
                                  role: "presentation"
                                }, [
                                  _createElementVNode("path", {
                                    d: "M16 7H9a3 3 0 0 0 0 6h5a3 3 0 0 1 0 6H8",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "1.6",
                                    "stroke-linecap": "round"
                                  }),
                                  _createElementVNode("path", {
                                    d: "M12 3v19",
                                    stroke: "currentColor",
                                    "stroke-width": "1.6",
                                    "stroke-linecap": "round"
                                  })
                                ])
                              ], -1)),
                              _createTextVNode(" " + _toDisplayString(entry.price || "Preis folgt"), 1)
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "landing-card__choice-label" }, "Gericht", -1)),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: _normalizeClass(["landing-card__choice-btn", {
                        'landing-card__choice-btn--active':
                          _ctx.selectedMealType(entry) === 'daily',
                      }]),
                                  onClick: ($event: any) => (_ctx.setMealType(entry, 'daily'))
                                }, " Tagesgericht ", 10, _hoisted_29),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: _normalizeClass(["landing-card__choice-btn", {
                        'landing-card__choice-btn--active':
                          _ctx.selectedMealType(entry) === 'weekly',
                      }]),
                                  disabled: !_ctx.weeklyMenuItem,
                                  onClick: ($event: any) => (_ctx.setMealType(entry, 'weekly'))
                                }, " Wochengericht ", 10, _hoisted_30)
                              ]),
                              _createElementVNode("div", _hoisted_31, [
                                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "landing-card__quantity-label" }, [
                                  _createElementVNode("span", {
                                    class: "landing-card__quantity-icon",
                                    "aria-hidden": "true"
                                  }, [
                                    _createElementVNode("svg", {
                                      viewBox: "0 0 20 20",
                                      role: "presentation"
                                    }, [
                                      _createElementVNode("rect", {
                                        x: "3",
                                        y: "9",
                                        width: "14",
                                        height: "2",
                                        rx: "1"
                                      }),
                                      _createElementVNode("rect", {
                                        x: "9",
                                        y: "3",
                                        width: "2",
                                        height: "14",
                                        rx: "1"
                                      })
                                    ])
                                  ]),
                                  _createTextVNode(" Anzahl ")
                                ], -1)),
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "landing-card__quantity-btn",
                                    disabled: !_ctx.canDecreaseOrderAmount(entry),
                                    onClick: ($event: any) => (_ctx.decreaseOrderAmount(entry))
                                  }, " - ", 8, _hoisted_33),
                                  _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.entryOrderAmount(entry)), 1),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "landing-card__quantity-btn",
                                    disabled: !_ctx.canIncreaseOrderAmount(entry),
                                    onClick: ($event: any) => (_ctx.increaseOrderAmount(entry))
                                  }, " + ", 8, _hoisted_35)
                                ])
                              ]),
                              _createElementVNode("button", {
                                class: "landing-card__order",
                                disabled: 
                      !_ctx.canOrder(entry) ||
                      _ctx.isOrdering(entry) ||
                      _ctx.isOrderLocked(entry)
                    ,
                                onClick: ($event: any) => (_ctx.orderMeal(entry))
                              }, [
                                _cache[12] || (_cache[12] = _createElementVNode("span", {
                                  class: "landing-card__order-icon",
                                  "aria-hidden": "true"
                                }, [
                                  _createElementVNode("svg", {
                                    viewBox: "0 0 24 24",
                                    role: "presentation"
                                  }, [
                                    _createElementVNode("path", {
                                      d: "M5 12h14",
                                      stroke: "currentColor",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round"
                                    }),
                                    _createElementVNode("path", {
                                      d: "M13 6l6 6-6 6",
                                      stroke: "currentColor",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    })
                                  ])
                                ], -1)),
                                (_ctx.isOrdering(entry))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Wird gespeichert ..."))
                                  : (_ctx.isOrderLocked(entry))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_38, "Bestätigt (gesperrt)"))
                                    : (_ctx.isOrdered(entry))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_39, "Bestellung aktualisieren"))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_40, "Für diesen Tag bestellen"))
                              ], 8, _hoisted_36),
                              (_ctx.canCancel(entry))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "landing-card__cancel",
                                    disabled: _ctx.isCanceling(entry),
                                    onClick: ($event: any) => (_ctx.cancelOrder(entry))
                                  }, [
                                    _cache[13] || (_cache[13] = _createElementVNode("span", {
                                      class: "landing-card__cancel-icon",
                                      "aria-hidden": "true"
                                    }, [
                                      _createElementVNode("svg", {
                                        viewBox: "0 0 24 24",
                                        role: "presentation"
                                      }, [
                                        _createElementVNode("path", {
                                          d: "M6 6l12 12M18 6l-12 12",
                                          stroke: "currentColor",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round"
                                        })
                                      ])
                                    ], -1)),
                                    (_ctx.isCanceling(entry))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_42, "Wird storniert ..."))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_43, "Bestellung stornieren"))
                                  ], 8, _hoisted_41))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          (_ctx.orderStateMessage(entry))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(_ctx.orderStateMessage(entry)), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    (_ctx.weeklyMenuItem)
                      ? (_openBlock(), _createElementBlock("article", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("small", _hoisted_47, [
                              _cache[14] || (_cache[14] = _createElementVNode("span", {
                                class: "landing-card__weekday-icon",
                                "aria-hidden": "true"
                              }, [
                                _createElementVNode("svg", {
                                  viewBox: "0 0 20 20",
                                  role: "presentation"
                                }, [
                                  _createElementVNode("circle", {
                                    cx: "10",
                                    cy: "10",
                                    r: "8",
                                    stroke: "currentColor",
                                    "stroke-width": "1.5",
                                    fill: "none"
                                  }),
                                  _createElementVNode("circle", {
                                    cx: "10",
                                    cy: "10",
                                    r: "2",
                                    fill: "currentColor"
                                  })
                                ])
                              ], -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.weeklyMenuItem.day), 1)
                            ]),
                            _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.formatDate(_ctx.weeklyMenuItem)), 1)
                          ]),
                          _createElementVNode("h2", _hoisted_49, _toDisplayString(_ctx.weeklyMenuItem.title || "Wochengericht"), 1),
                          (_ctx.weeklyMenuItem.details && _ctx.weeklyMenuItem.details.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weeklyMenuItem.details, (line, detailIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: detailIndex,
                                    class: "landing-card__detail"
                                  }, _toDisplayString(line), 1))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("span", _hoisted_52, [
                              _cache[15] || (_cache[15] = _createElementVNode("span", {
                                class: "landing-card__price-icon",
                                "aria-hidden": "true"
                              }, [
                                _createElementVNode("svg", {
                                  viewBox: "0 0 24 24",
                                  role: "presentation"
                                }, [
                                  _createElementVNode("path", {
                                    d: "M16 7H9a3 3 0 0 0 0 6h5a3 3 0 0 1 0 6H8",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "1.6",
                                    "stroke-linecap": "round"
                                  }),
                                  _createElementVNode("path", {
                                    d: "M12 3v19",
                                    stroke: "currentColor",
                                    "stroke-width": "1.6",
                                    "stroke-linecap": "round"
                                  })
                                ])
                              ], -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.weeklyMenuItem.price || "Preis folgt"), 1)
                            ]),
                            _cache[16] || (_cache[16] = _createElementVNode("p", { class: "landing-card__weekly-hint" }, " Dieses Gericht steht dir über den Schalter neben jedem Bestellbutton zur Auswahl. ", -1))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock("section", _hoisted_53, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "landing__history-head" }, [
                      _createElementVNode("h2", null, "Deine Bestellhistorie")
                    ], -1)),
                    _createVNode(_component_OrderHistory)
                  ]))
            ]))
    ])
  ]))
}